// How far back to check for agents having gone offline.
export const MINUTES_INTERVAL = 30;
